import React from "react";

import menu1 from "./images/menu1.jpeg";
// import menu2 from "./images/menu2.jpeg";

export default function price() {
  return (
    <div className="max-w-7xl mx-auto pt-28 pb-10 px-4 sm:px-6 lg:px-8">
      {/* <h1 className="text-3xl font-extrabold text-gray-900 mb-8 text-center">Our Menu</h1> */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        <div>
          <img
            src={menu1}
            alt="Menu Page 1"
            className="w-full rounded-lg shadow-md"
          />
        </div>
        {/* <div>
          <img
            src={menu2}
            alt="Menu Page 2"
            className="w-full rounded-lg shadow-md"
          />
        </div> */}
      </div>
    </div>
  );
}
